import { h, render } from 'preact'
import { Provider } from 'react-redux'
import store from './state/store.js'

import DemoApp from './components/DemoApp.jsx'

import './style/shared/base.less'
import './style/components/Button.less'
import './style/components/Input.less'

render(
	<Provider store={ store }>
		<div>
			<DemoApp />
		</div>
	</Provider>,
	document.querySelector('main')
)
